
export default {
  props: {
    component: {
      type: Object,
      default() {
        return {
          teaser: '<p><em>Service</em> wird bei uns grossgeschrieben.</p>',
          subtitle: `<p>Haben Sie gewusst, dass die meisten Ihr <em>Treppenhaus</em> falsch oder zu umständlich <strong>Putzen</strong>? Mit diesem Guide lernende was wir empfehlen um mit minimalem Zeitaufwand das <a title="Beam mich hoch" href="https://novu.ch">Beste Resultat</a> zu erhalten.</p>`,
          category: [],
          image: {
            url: require('~/assets/img/placeholders/atramex-building.jpg'),
            alt: 'Atramex Gebäude von Aussen',
          },
        }
      },
    },
  },
}
